import { render, staticRenderFns } from "./configField.vue?vue&type=template&id=0a4484e0&scoped=true"
import script from "./configField.vue?vue&type=script&lang=js"
export * from "./configField.vue?vue&type=script&lang=js"
import style0 from "./configField.vue?vue&type=style&index=0&id=0a4484e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4484e0",
  null
  
)

export default component.exports